import { Country } from "./country.model";

export class CoronerModel {
  corId: string;
  corName: string;
  corPostalCode: string;
  corCity: string;
  corCountry = new Country();
  corHouseNumber: string;
  corHouseNumberAddition: string;
  corStreetName: string;
  corPhoneNumber: string;
  corIsInNetherlends: boolean;
  corContactPerson: string;
  corDeathDetailId: string;
}